import React, { useState, useEffect } from 'react'

const OLX_OAUTH_SECRET = process.env.REACT_APP_OLX_OAUTH_SECRET || 'secret'
const OLX_OAUTH_CLIENT_ID = process.env.REACT_APP_OLX_OAUTH_CLIENT_ID
const OLX_OAUTH_CLIENT_SECRET = process.env.REACT_APP_OLX_OAUTH_CLIENT_SECRET

const OLX_OAUTH_URL = 'https://auth.olx.com.br/oauth'
const OLX_TOKEN_URL = 'https://auth.olx.com.br/oauth/token'

function OLXOAuth() {
  const redirectURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
  const urlParams = new URLSearchParams(window.location.search)
  const state = urlParams.get('state')
  const code = urlParams.get('code')
  const action = urlParams.get('action')

  const [isLoading, setIsLoading] = useState(false)
  const [accessToken, setAccessToken] = useState(undefined)

  const authorized = state === OLX_OAUTH_SECRET

  useEffect(() => {
    async function fetchData() {
      if (code && action !== 'redirect' && authorized) {
        try {
          setIsLoading(true)
          const data = await fetch(OLX_TOKEN_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `code=${code}&client_id=${OLX_OAUTH_CLIENT_ID}&client_secret=${OLX_OAUTH_CLIENT_SECRET}&redirect_uri=${redirectURL}&grant_type=authorization_code`,
          })
          .then(response => {
            return response.json()
          })

          setAccessToken(data.accessToken)
        } catch (error) {
          setAccessToken('ERROR')
        } finally {
          setIsLoading(false)
        }
      }
    }
    fetchData()
  }, [code, redirectURL, action, authorized]) // eslint-ignore

  if (!authorized) {
    return (<div>Not authorized</div>)
  }

  if (action === 'redirect') {
    window.location.replace(`${OLX_OAUTH_URL}?scope=autoupload&state=${state}&redirect_uri=${redirectURL}&response_type=code&client_id=${OLX_OAUTH_CLIENT_ID}`)
    return (<div>Redirecting...</div>)
  }

  if (isLoading) {
    return (<div>Loading...</div>)
  }

  if (accessToken) {
    return (<div>Access Token: {accessToken}</div>)
  }

  return (<div>Something is wrong</div>)
}

export default OLXOAuth
